import { filing } from './toolkit';


/**
 * Inventory of assets (Form I-1, Uniform Rule 207.20), 1 page.
 * Categories A to G, totals and the filing fee are computed from Assets (court inventory category and
 * market value) in summary/court-financials.ts; the non-estate asset questions come from the assets'
 * court inventory categories.
 */
export default filing('file-1787254124533-9a37a808-cd92-4530-a851-17aaaaa71d3e.pdf', 'Inventory of assets', f => {
  f.shared('County of', 'estate.surrogateCourtCountyOption', "Surrogate's Court, County of (court county matched to the form's county list)");
  f.shared('Dececedent', 'decedent.fullName', 'In the Matter of (decedent name), Deceased');
  f.shared('File Number', 'estate.courtFileNumber', 'File number');

  // Box: to be completed by fiduciary or attorney for fiduciary.
  f.shared('Total_Estate_Assets', 'totals.inventoryTotal', 'Total estate assets');
  f.shared('FilingFeeSCPA2402', 'totals.inventoryFilingFee', 'Filing fee SCPA 2402(7)');
  f.shared('FilingFeeInitiallyPaid', 'totals.inventoryFilingFeeInitiallyPaid', 'Filing fee initially paid');
  f.shared('Balance (Refund) Due', 'totals.inventoryBalanceDue', 'Balance (refund) due');

  f.shared('Date of Death', 'decedent.dateOfDeath', 'Date of death');
  f.shared('Date of Letters', 'estate.dateOfLetters', 'Date of letters');
  f.shared('Type of Letters', 'estate.typeOfLetters', 'Type of letters');
  f.template('Fiduciary Name and Address (if changed)', '{{executor.fullName}}, {{executor.fullAddress}}',
    'Name of fiduciary(ies) and, if changed, fiduciary(ies) address');

  // Assets individually owned by the decedent or payable to the estate: category A to G.
  f.shared('Real Estate', 'totals.inventoryRealEstateCategory', '1. Real estate: category');
  f.shared('Stocks and Bonds', 'totals.inventoryStocksBondsCategory', '2. Stocks and bonds: category');
  f.shared('Insurance Payable to Estate', 'totals.inventoryInsuranceEstateCategory', '3. Insurance payable to estate: category');
  f.shared('IRAs 401ks Payable to Estate', 'totals.inventoryRetirementEstateCategory', '4. IRAs, 401(k)s payable to estate: category');
  f.shared('Morgages and Notes Held by Decedent', 'totals.inventoryMortgagesNotesCategory', '5. Mortgages or notes held by decedent: category');
  f.shared('Cash', 'totals.inventoryCashCategory', '6. Cash: category');
  f.shared('Miscellaneous', 'totals.inventoryMiscellaneousCategory', '7. Miscellaneous: category');
  f.shared('Firearms', 'totals.inventoryHasFirearms', '8. Firearms: Yes (see attached firearms inventory) or None');
  f.shared('TotalEstateAssets', 'totals.inventoryTotalCategory', 'Total estate assets: category');

  // Non-estate assets: yes or no to each.
  f.shared('Living Trust', 'totals.inventoryHasLivingTrust', '9. Living trust: yes or no');
  f.shared('Name of Trustee(s)', 'estate.trusteeNames', '9. If yes, name of the trustee(s)');
  f.shared('Gifts in Excess of Federal Exclusion', 'totals.inventoryHasTaxableGifts',
    '10. Gifts in excess of federal annual exclusion made within 3 years of death: yes or no');
  f.shared('Jointly Held Property', 'totals.inventoryHasJointProperty', '11. Jointly held property (real or personal): yes or no');
  f.shared('Insurance Payable to Beneficiary', 'totals.inventoryHasInsuranceBeneficiary', '12. Insurance payable to beneficiary: yes or no');
  f.shared('IRA 401K Payable to Beneficiary', 'totals.inventoryHasRetirementBeneficiary', "13. IRAs, 401(k)s payable to beneficiary: yes or no");
  f.shared('Annuities', 'totals.inventoryHasAnnuities', '14. Annuities: yes or no');
  f.shared('Powers of Appointment', 'totals.inventoryHasPowersOfAppointment', '15. Powers of appointment: yes or no');
  f.shared('Cause(s) of Pending Action', 'estate.pendingActionAnswer', '16. Cause(s) of action pending: yes or no (Estate details: pending court action)');
  f.shared('Court and Index Number', 'estate.pendingActionCourtIndex', '16. If yes, court and index number');

  // Certification.
  f.signature('Day', 'Certified to be true on the __ day: date signed (completed at signing)');
  f.signature('Month', 'Certified to be true on the day of (month): date signed (completed at signing)');
  f.signature('Year', 'Certified to be true, 20__ (year): date signed (completed at signing)');
  f.shared('Print Name', 'executor.fullName', 'Print name (fiduciary signing the certification)');
  f.shared("Attorney's Name", 'lawyer.fullName', "Attorney's name");
  f.shared("Attorney's Address", 'lawyer.fullAddress', "Attorney's address");
  f.shared("Attorney's Telephone Number", 'lawyer.phone', "Attorney's telephone no.");
});
